/*
 * Splectrum Picks — <next-drop> countdown (sections/next-drop.liquid).
 * Liquid renders the first value; this keeps days / hours / minutes current
 * (ticks every 20 s, and immediately when the tab becomes visible) and swaps
 * to the "Out now" state once data-date has passed.
 */
(function () {
  if (customElements.get('next-drop')) return;

  class NextDrop extends HTMLElement {
    connectedCallback() {
      this.target = new Date(this.dataset.date);
      if (isNaN(this.target.getTime())) return;
      this.days = this.querySelector('[data-nd-days]');
      this.hours = this.querySelector('[data-nd-hours]');
      this.mins = this.querySelector('[data-nd-mins]');
      this.count = this.querySelector('.next-drop__count');
      this.out = this.querySelector('[data-nd-out]');
      this.dateLive = this.querySelector('.next-drop__date-live');
      this.tick = this.tick.bind(this);
      this.onVisibility = this.onVisibility.bind(this);
      this.tick();
      this.timer = setInterval(this.tick, 20000);
      document.addEventListener('visibilitychange', this.onVisibility);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
      document.removeEventListener('visibilitychange', this.onVisibility);
    }

    onVisibility() {
      if (!document.hidden) this.tick();
    }

    tick() {
      const diff = this.target.getTime() - Date.now();
      if (diff <= 0) {
        if (this.count) this.count.classList.add('is-expired');
        if (this.out) this.out.classList.remove('hidden');
        if (this.dateLive && this.dataset.expiredLabel) this.dateLive.textContent = this.dataset.expiredLabel;
        clearInterval(this.timer);
        return;
      }
      const total = Math.floor(diff / 60000);
      const d = Math.floor(total / 1440);
      const h = Math.floor((total % 1440) / 60);
      const m = total % 60;
      if (this.days) this.days.textContent = d;
      if (this.hours) this.hours.textContent = h;
      if (this.mins) this.mins.textContent = m;
    }
  }

  customElements.define('next-drop', NextDrop);
})();
